/*generates hash object using two dimensional Array and key of sepcified type
refData - Array of data with Type <T> which is used to generate hash Object
key is of which its value to be returned as hash key
returns object of (value of param key: group index , row index) => key value: [index,index] - hash Object
*/
export function genHshObj<T>(refData: Array<Array<T>>, key: keyof T) {
	const hash: { [x: string]: [number, number] } = {};
	refData.forEach((group: Array<T>, gI: number) =>
		group.forEach((row: T, i: number) => {
			const sym: any = row[key];
			hash[sym] = [gI, i];
		})
	);
	return hash;
}
